import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {Icon, stringUtils} from 'front-onceforall-core';

import {planPropTypes} from '../../../../../utils/propTypes';

import {renderPriceUnit} from '../../../utils';

function Option({plan, option}) {
  const translatedValue = stringUtils.getStrongs(I18n.t(
    `subscriptions.plans.services.${option.id}`,
    {count: option.quantity, ...option}
  ));

  return (
    <div
      key={`option-${plan.externalId}-${option.id}`}
      className="col-12 inline-container mb-4"
    >
      <Icon
        icon="plus"
        size={12}
      />
      <div>
        <div className="font-size-xs">{translatedValue}</div>
        <div>
          <strong className="font-size-xs">
            {renderPriceUnit(option.price / 12, plan.currency, 'month', option.unit)}
          </strong>
        </div>
      </div>
    </div>
  );
}

Option.propTypes = {
  plan: planPropTypes().isRequired,
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    unit: PropTypes.string,
    quantity: PropTypes.number.isRequired
  }).isRequired
};

export default Option;
